import { render, staticRenderFns } from "./VueComponentsCreate.vue?vue&type=template&id=739f9d55"
import script from "./VueComponentsCreate.vue?vue&type=script&lang=js"
export * from "./VueComponentsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports